<template lang="pug">
	.creative-audio-pixel
		Loader(v-if="isLoading && !audioPixels.length", :fullscreen="true")
		.flex-col.space-large(v-else)
			.flex-col.field.pixel-type(v-for="item in audioPixels")
				.font-small.upper.grey {{item.name}}
				.flex-row.align-center.space
					Loader(v-if="item.__isLoading", text="")
					DxTextBox.flex-1(:value.sync="item.pixel.CallbackUrl", :placeholder="$tCaption('Callback url')", :disabled="item.__isLoading", @value-changed="createUpdateAudioPixel(item)")
</template>

<script>
	import { AUDIO_PIXEL_TYPES } from 'app-core/constants';
	import DxTextBox from 'devextreme-vue/text-box';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'creative.CreativeAudioPixel',
		name: 'creative-audio-pixel',
		props: ['creativeId'],
		components: { DxTextBox, Loader },
		data() {
			return {
				columns: [
					{ dataField: 'PixelTypeName', caption: () => this.$tCaption('PixelType') },
					{ dataField: 'CallbackUrl', caption: () => this.$tCaption('CallbackUrl') }
				],
				audioPixelTypes: AUDIO_PIXEL_TYPES.toLocale('name', this),
				newPixelPopup: false,
				creativeAudioPixels: [],
				isLoading: false,
				audioPixels: []
			};
		},
		mounted() {
			if (__DEBUG__)
				window.creativeAudioPixel = this;
			this.loadData();
		},
		methods: {
			loadData(page, limit, opts) {
				this.isLoading++;
				return this.$Data.getExternalApi('AudioPixel/GetAllAudioPixels', `page=${page}&creativeId=${this.creativeId}`, 999).then(r => {
					this.audioPixels = this.audioPixelTypes.map((f, i) => ({
						name: f.name,
						pixel: r.Results.find(p => p.PixelType === i) || {
							Oid: null,
							PixelType: i,
							CallbackUrl: null,
							Creative: {
								Oid: this.creativeId
							}
						}
					}))
				}).finally(() => this.isLoading--);
			},
			createUpdateAudioPixel(item) {
				if (item?.pixel?.CallbackUrl) {
					this.$set(item, '__isLoading', true);
					this.$Data.postExternalApi('AudioPixel/CreateUpdateAudioPixel', item.pixel)
						.then(r => {
							if (!r?.Success !== false) {
								if (!item?.pixel?.Oid) {
									item.pixel.Oid = r?.Data?.Oid;
								}
							}
						})
						.finally(() => item.__isLoading = false);
				} else {
					if (item?.pixel?.Oid) {
						this.$set(item, '__isLoading', true);
						this.$Data.getExternalApi('AudioPixel/DeleteAudioPixel', `id=${item.pixel.Oid}`)
							.finally(() => item.__isLoading = false);;
					}
				}
			}
		}
	};
</script>
<style lang='scss'>
	.creative-audio-pixel {
	}
</style>
